import {serviceRequestActions} from '../actions'
import {constants as kandyConstants} from 'kandy-redux'
import {isFSA} from 'flux-standard-action'

let middleware = ({dispatch, getState}) => {
	return next => action => {
		if (isFSA(action) && action.type === kandyConstants.MESSAGE_JSON_RECEIVED) {
			if (action.payload.message.message.json.type === 'JSON_END_SESSION') {

				var userId = action.payload.message.sender.full_user_id
				var appState = getState().app

				// Only end the session if it hasn't already been ended.
				if (appState.customers.current.filter(customer => customer.userId === userId).length === 0) {
					dispatch(serviceRequestActions.endSession(userId))
				}

			}
		}

		return next(action)
	}
}

export default middleware
